import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import { ReactComponent as ApproveIcon } from '../../../assets/icons/approve-icon.svg';
import { ReactComponent as RejectIcon } from '../../../assets/icons/reject-icon.svg';
import { ReactComponent as ReplaceIcon } from '../../../assets/icons/replace-icon.svg';
import { AttachmentStatus } from '../../../models/models';
import { approveAttachmentStart } from '../../../store/attachment/attachment.action';
import { closeDialog, openDialog } from '../../../store/dialog/dialog.action';
import { DIALOG_TYPES } from '../../../store/dialog/dialog.types';
import { getNodeStart } from '../../../store/node/node.action';
import { selectNodeSelected } from '../../../store/node/node.selector';
import {
    canApproveAttachment,
    canRejectAttachment,
    canReplaceAttachment,
} from '../../../utils/role/role.utils';
import { FlexBoxFullH, FlexBoxFullWHRow } from '../../layout/layout.styles';
import DialogContent from '../../ui/dialog-content/dialog-content.component';
import DialogTitle from '../../ui/dialog-title/dialog-title.component';
import {
    ApproveText,
    RejectText,
    ReplaceText,
} from './dialog-select-attachment-action.styles';

const DialogSelectAttachmentAction = ({ inputData }: { inputData: any }) => {
    const dispatch = useDispatch();
    const nodeSelected = useSelector(selectNodeSelected);

    const status: AttachmentStatus = inputData.status;

    const handleApprove = () => {
        dispatch(
            approveAttachmentStart(inputData.id, inputData.type, () => {
                dispatch(closeDialog());
                dispatch(getNodeStart(nodeSelected!.id));
            })
        );
    };

    const handleReject = () => {
        dispatch(openDialog(DIALOG_TYPES.REJECT_ATTACHMENT, inputData));
    };

    const handleReplace = () => {
        dispatch(openDialog(DIALOG_TYPES.REPLACE_ATTACHMENT, inputData));
    };

    return (
        <Fragment>
            <DialogTitle title="Validazione" />
            <DialogContent height={'170px'}>
                <FlexBoxFullWHRow justifyContent={'center'}>
                    {status !== 'approved' &&
                        status !== 'rejected' &&
                        canApproveAttachment(nodeSelected!) && (
                            <FlexBoxFullH
                                flexDirection={'column'}
                                alignItems={'center'}
                                width={'50%'}
                            >
                                <ApproveIcon
                                    onClick={handleApprove}
                                    style={{ cursor: 'pointer' }}
                                />
                                <ApproveText>Approva</ApproveText>
                            </FlexBoxFullH>
                        )}
                    {status !== 'rejected' &&
                        canRejectAttachment(nodeSelected!) && (
                            <FlexBoxFullH
                                flexDirection={'column'}
                                alignItems={'center'}
                                width={'50%'}
                            >
                                <RejectIcon
                                    onClick={handleReject}
                                    style={{ cursor: 'pointer' }}
                                />
                                <RejectText>Rifiuta</RejectText>
                            </FlexBoxFullH>
                        )}
                    {status === 'rejected' &&
                        canReplaceAttachment(nodeSelected!) && (
                            <FlexBoxFullH
                                flexDirection={'column'}
                                alignItems={'center'}
                                width={'50%'}
                            >
                                <ReplaceIcon
                                    onClick={handleReplace}
                                    style={{ cursor: 'pointer' }}
                                />
                                <ReplaceText>Sostituisci</ReplaceText>
                            </FlexBoxFullH>
                        )}
                </FlexBoxFullWHRow>
            </DialogContent>
        </Fragment>
    );
};

export default DialogSelectAttachmentAction;
